module.exports = __webpack_public_path__ + "static/media/ck.8b394ddb.webp";